import { useCallback, useState } from 'react';

export const useCollapseSections = () => {
  const [expanded, setExpanded] = useState<Record<string, boolean>>({});
  const handleStateChange = useCallback((id: string, expanded: boolean) => {
    setExpanded((p) => {
      return { ...p, [id]: expanded };
    });
  }, []);
  const registerKey = useCallback((key: string) => {
    setExpanded((p) => ({ ...p, [key]: false }));
  }, []);

  const handleExpandAll = useCallback(() => {
    const newState: Record<string, boolean> = {};
    Object.keys(expanded).forEach((k) => (newState[k] = true));
    setExpanded(newState);
  }, [expanded]);

  const handleCollapseAll = useCallback(() => {
    const newState: Record<string, boolean> = {};
    Object.keys(expanded).forEach((k) => (newState[k] = false));
    setExpanded(newState);
  }, [expanded]);

  const allCollapsed = useCallback(
    () => Object.values(expanded).some((v) => v),
    [expanded]
  );
  const allExpanded = useCallback(
    () => Object.values(expanded).some((v) => !v),
    [expanded]
  );
  const isExpanded = useCallback((id: string) => expanded?.[id] ?? false, [
    expanded,
  ]);

  return {
    handleCollapseAll,
    handleExpandAll,
    handleStateChange,
    allCollapsed,
    allExpanded,
    isExpanded,
    state: expanded,
    registerKey,
  };
};
